div:has(> .programmePageNavigation, > .sidemenu) {
    display: contents; /* Make the top level element in the react-app appear as the layout element instead of the react-wrapper just existing for react-rendering */
}

:global(.bi-sub-navbar--wrapper):has(.programmePageNavigation) {
    height: 0;
}

.programmePageNavigation {
    &:not([data-fixed='true']) {
        display: none;
    }

    > div {
        max-width: 1128px;
        margin: 0 auto;
        display: flex;
        gap: var(--bi-scale-1x);
        justify-content: space-between;
        align-items: center;
        padding: var(--bi-scale-1x) 0;

        @media (width < 1128px) {
            padding: var(--bi-scale-1x) var(--bi-scale-4x) var(--bi-scale-1x) var(--bi-scale-1x);
        }

        .trigger {
            min-width: 128px;
            max-width: 368px;
            justify-content: space-between;
            flex: 1;
            padding: var(--bi-scale-2x) var(--bi-scale-5x);

            @media (width < 768px) {
                padding: var(--bi-scale-2x) var(--bi-scale-3x);
            }

            .triggerIcon {
                transition: rotate 0.2s;
            }

            &[aria-expanded='true'] {
                .triggerIcon {
                    rotate: 180deg;
                }
            }

            > span:first-of-type {
                overflow: hidden;

                > span {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    display: block;
                    margin-bottom: calc(var(--bi-scale-0-50x) * -1);

                    &:first-of-type {
                        font: var(--bi-font-label-small);
                        color: var(--bi-primary-20);
                    }
                }
            }
        }

        /* The design system's button doesn't shrink, so a long label would push past the screen edge instead of wrapping. */
        > :global(.bi-button):not(.trigger) {
            flex-shrink: 1;
            min-width: min-content;
        }

        .dropdown {
            --bic-dropdown-background: var(--bi-color-surface);
            --bic-dropdown-padding: 0;
            --bic-dropdown-border-width: 0;
            --programme-nav-border-radius: var(--bi-scale-11x);
            border-radius: 0 0 var(--programme-nav-border-radius) 0;
            padding-top: var(--bi-scale-1x);

            @media (width < 768px) {
                --bic-dropdown-min-width: 100dvw;
            }
        }
    }
}

.sidemenu {
    display: flex;
    flex-direction: column;
    align-self: start;
    z-index: 1;
    width: 100%;

    grid-column: var(--product-page-grid-sidebar-columns);
    grid-row: span 2; /* Span multiple rows to ensure it's always visible */

    padding-top: var(--bi-scale-8x);

    --programme-nav-border-radius: var(--bi-scale-12x);

    > div {
        margin: var(--bi-scale-6x) 0 var(--bi-scale-2x) var(--bi-scale-5x);
    }

    .programmeInfo {
        --category-color: var(--bi-primary-60);
        --credits-color: var(--bi-neutral-60);
        font: var(--bi-font-label-small);
        color: var(--bi-color-text-accent);

        > span,
        > svg {
            font: var(--bi-font-body-small);
            color: var(--bi-color-text-secondary);
        }

        > svg {
            vertical-align: text-bottom;
            margin: 0 var(--bi-scale-0-25x);
        }
    }
    .programmeName {
        font: var(--bi-font-title-bold-xs);
        color: var(--bi-color-text);
        margin-bottom: var(--bi-scale-3x);
    }
}

.buttonList {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0;

    > li {
        > hr {
            margin: 0;
            border: none;
            border-top: 1px solid var(--bi-color-stroke-subtle);
            opacity: 0.5;
        }

        &:has(> .button[aria-current='true']) {
            background: var(--bi-basic-white);
            box-shadow:
                0 0 20px var(--bi-scale-1-5x) rgba(0, 0, 0, 0.05),
                0 0 10px 0 rgba(0, 0, 0, 0.05);

            &[data-color-scheme='dark'] {
                background: color-mix(in srgb, var(--bi-basic-white) 10%, transparent);
                box-shadow: none;
            }
        }

        > .button {
            padding: var(--bi-scale-2x) var(--bi-scale-4x) var(--bi-scale-2x) var(--bi-scale-4x);
            border-left: var(--bi-scale-1x) solid transparent;
            border-radius: 0;
            color: var(--bi-color-text);
            width: 100%;
            justify-content: flex-start;
            font: var(--bi-font-body-medium);

            @media (width < 768px) {
                padding-left: var(--bi-scale-3x);
            }

            &[aria-current='true'] {
                border-left-color: var(--bi-color-primary-stroke-accent);
            }
        }

        .sidemenu &:first-of-type {
            border-radius: 0 var(--programme-nav-border-radius) 0 0;
            > .button {
                border-radius: 0 var(--programme-nav-border-radius) 0 0;
            }
        }
        &:last-of-type {
            border-radius: 0 0 var(--programme-nav-border-radius) 0;
            > .button {
                border-radius: 0 0 var(--programme-nav-border-radius) 0;
            }
        }
    }
}
